import { useTranslation } from 'react-i18next';

import logo from '@assets/logos/astropay-logo.png';
import { APImage } from '@components/atoms/APImage';

export const Header = () => {
  const { t } = useTranslation();

  return (
    <div className="p-6 flex justify-center items-center">
      <APImage img={logo} width={114} height={29} alt={t('AstroPayDownload.title')} />
    </div>
  );
};
